import * as FaIcons from "react-icons/fa6";
import * as MdIcons from "react-icons/md";

export function getDepartmentName(slug, departments) {
    const department = departments.find((dept) => dept.slug === slug);
    return department ? department.name : "अज्ञात विभाग"; // Fallback: "Unknown Department"
}

export function getCategoryName(departmentSlug, categorySlug, departments) {
    const department = departments.find((dept) => dept.slug === departmentSlug);
    if (!department) return "अज्ञात श्रेणी"; // Fallback: "Unknown Category"
  
    const category = department.categories.find((cat) => cat.slug === categorySlug);
    return category ? category.name : "अज्ञात श्रेणी";
}

export function getSubcategoryName(departmentSlug, categorySlug, subcategorySlug, departments) {
    const department = departments.find((dept) => dept.slug === departmentSlug);
    if (!department) return "अज्ञात उप-श्रेणी"; // Fallback: "Unknown Subcategory"
  
    const category = department.categories.find((cat) => cat.slug === categorySlug);
    if (!category) return "अज्ञात उप-श्रेणी";
  
    const subcategory = category.subcategory.find((subcat) => subcat.slug === subcategorySlug);
    return subcategory ? subcategory.name : "अज्ञात उप-श्रेणी";
}

export const getIconLibrary = (library) => {
    switch (library.toLowerCase()) {
        case 'fa':
        return FaIcons;
        case 'md':
        return MdIcons;
        default:
        return null;
    }
};

export const renderIcon = (iconName, library) => {
    const iconLibrary = getIconLibrary(library);
    
    if (!iconLibrary) {
        console.warn(`Icon library ${library} not found`);
        return null;
    }

    const IconComponent = iconLibrary[iconName];
    
    if (IconComponent) {
        return <IconComponent />;
    }
    
    console.warn(`Icon ${iconName} not found in ${library} library`);
    return null;
};


// Convert to uppercase
export const toUppercase = (str) => str.toUpperCase();

// Convert to sentence case (capitalize first letter of each sentence)
export const toSentenceCase = (str) => {
  return str
    .split(". ") // Split into sentences
    .map((sentence) => sentence.charAt(0).toUpperCase() + sentence.slice(1))
    .join(". "); // Join sentences back
};

// Convert to title case (capitalize first letter of each word)
export const toTitleCase = (str) => {
  return str
    .split(" ") // Split into words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" "); // Join words back
};

export const decodeToken = (token) => {
    try {
        const base64Url = token.split('.')[1]; // Get payload
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const decodedData = JSON.parse(atob(base64));
        return decodedData;
    } catch (error) {
        console.error('Invalid token', error);
        return null;
    }
}

export const isTokenExpired = (token) => {
    if (!token) return true; // No token means it's "expired"

    const decodedToken = decodeToken(token);
    const currentTime = Date.now() / 1000; // Convert to seconds

    return decodedToken.exp < currentTime; // Check if token expiration time is in the past
};

export const getStatusBadgeColor = (status) => {
    switch (status) {
        case 'Completed': return 'success';
        case 'In Progress': return 'primary';
        case 'Delayed': return 'warning';
        default: return 'secondary';
    }
}